// State shape for the shared <BricklinkUploadDialog />. Every page that renders the
// dialog splices this schema into its page schema under the fixed key
// `bricklinkUploadDialog`, which the component reads through its `pageName` prop.
export const bricklinkUploadDialogStateSchema = {
    type: 'object',
    properties: {
        isOpen: {
            type: 'boolean',
            default: false
        },
        items: {
            type: 'array',
            items: {
                type: 'object'
            },
            default: []
        },
        itemCount: {
            type: 'number',
            default: 0
        },
        skippedCount: {
            type: 'number',
            default: 0
        },
        // Key of BRICKLINK_XML_FLAVOURS. Drives every string the dialog renders
        // and the URL its open button targets. It travels in state rather than as
        // a prop so the opener and the dialog cannot disagree about the flavour.
        flavour: {
            type: 'string',
            default: 'storeInventory'
        }
    }
};
